import { useRouter } from "next/navigation";

export const useRouterBack = (): {
  routerBack: () => void;
} => {
  const router = useRouter();

  const routerBack = () => {
    if (window?.history?.length > 2) {
      router.back();
    }
    else {
      router.push("/");
    }
  };

  return { routerBack };
};
